<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-havip`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M45 41a1 1 0 00-1-1H4a1 1 0 00-1 1v2a1 1 0 001 1h40a1 1 0 001-1v-2zm0-33a2 2 0 00-2-2H5a2 2 0 00-2 2v27a2 2 0 002 2h38a2 2 0 002-2V8zM7 10h34v23H7V10zm9 3v16.5h4V13h-4zm7 2v-2h6.5a5.5 5.5 0 110 11H27v5.5h-4V15zm4 5h2.5a1.5 1.5 0 000-3H27v3z"/></svg>
</template>
<script>

export default {
  name: 'IconHavip',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
